import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryHeader.js';
import { RichText } from '@synergycms_core/components/generic';
import { withContent } from '@synergycms_core/components/providers/translateProvider';


const AvailMainSideSummaryHeader = class AvailMainSideSummaryHeader extends React.Component {
  static displayName = 'AvailMainSideSummaryHeader';

  render() {
    const { theme } = this.props;
    const { classes } = theme.styles;

    return (
      <div>
        <RichText
          innerStyle={classes.modalTitle}
          ucFirst={true}
          text={'_%resumen de tu reserva%_'}
          translate={true}
        />
      </div>
    )
  }
};

export default compose(
  PropertyManager([

  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryHeader);
